import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';
import ReactModal from 'react-modal';
import mutateProps from 'utils/mutateProps';

import {
  selectShowDealClosed as selectShow,
} from 'flows/deal/status/reducer';

import {
  closedMutation as mutation,
  cancelClosed as cancelProp,
  closedProp as submitProp,
} from 'flows/deal/status';

import DealClosedConfirmation from './component';

export const DealClosedConfirmationContainer = ({show, submitLoading, submit, cancel, deal}) => (
  <ReactModal
    isOpen={show}
    contentLabel="What happens now?"
    shouldCloseOnOverlayClick
    className="ReactModal"
    ariaHideApp={false}
  >
    <DealClosedConfirmation
      sending={submitLoading}
      submit={submit}
      cancel={cancel}
      deal={deal}
    />
  </ReactModal>
);

DealClosedConfirmationContainer.propTypes = {
  deal: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  submitLoading: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

const mapMutation = props => ({
  submit: submitProp(props),
});

export const mapStore = store => ({
  show: selectShow(store),
});

export default compose(
  graphql(mutation, {
    props: mapMutation,
  }),
  mutateProps({name: 'submit'}),
  connect(mapStore, {cancel: cancelProp}),
)(DealClosedConfirmationContainer);



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/components/DealClosedConfirmation/index.js